import { FaCheckCircle, FaHeart, FaRegHeart } from "react-icons/fa";
import { useState } from "react";
import popularPropertiesImg from "../../../assets-user/popularProperty.png";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PopularProperties = () => {
  const [wishlist, setWishlist] = useState(Array(5).fill(false));
  const navigate = useNavigate();

  const toggleWishlist = (index) => {
    setWishlist((prev) => prev.map((item, i) => (i === index ? !item : item)));
  };

  const properties = Array(5).fill({
    id: 1,
    verified: true,
    image: popularPropertiesImg,
    type: "2 BHK Appartment",
    price: "₹2.5 Cr",
    location: "Kalinga Nagar, Near TATA Areana, Sum Hospital Road",
    postedTime: "1 Months ago",
  });

  return (
    <div className="w-full px-4 sm:px-6 md:px-8 lg:px-10  pb-6 md:pb-8 lg:pb-10">
      {/* Header */}
      <div className="flex justify-between items-center pb-6 md:pb-8 lg:pb-10">
        <h2 className="font-medium text-[#031722] text-lg sm:text-xl md:text-2xl">
          Popular Owner Property
        </h2>

        <button
          onClick={() => {
            navigate("/properties");
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-1 sm:gap-2 text-red-600 font-medium text-xs sm:text-base"
        >
          View all <ArrowRight className="w-3 sm:w-4 h-3 sm:h-4" />
        </button>
      </div>

      {/* Properties Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 ">
        {properties?.map((property, index) => (
          <div
            key={index}
            className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow"
            data-aos="fade-up"
            data-aos-delay={index * 100 + 80}
          >
            {/* Image Section  */}
            <div className="relative">
              <img
                src={property.image}
                alt={property.type}
                className="w-full h-48 object-cover"
              />
              {/* Verified Badge */}
              {property.verified && (
                <div className="absolute top-3 left-3 flex items-center gap-1 bg-green-600 text-white px-2 py-1 rounded text-xs font-medium">
                  <FaCheckCircle className="text-xs" />
                  <span>Verified</span>
                </div>
              )}
              {/* Price Badge */}
              <div className="absolute bottom-3 right-3 bg-white px-3 py-1 rounded shadow-md">
                <span className="font-semibold text-gray-900">
                  {property.price}
                </span>
              </div>
              {/* Area Badge (if exists) */}
              {property.area && (
                <div className="absolute bottom-3 left-3 bg-blue-500 text-white px-2 py-1 rounded text-xs font-medium">
                  {property.area}
                </div>
              )}
              {/* Heart Button */}
              <button
                onClick={() => toggleWishlist(index)}
                className="absolute top-3 right-3 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition-colors"
              >
                {wishlist[index] ? (
                  <FaHeart className="text-red-500 text-lg" />
                ) : (
                  <FaRegHeart className="text-gray-900 text-lg" />
                )}
              </button>
            </div>

            {/* Content Section */}
            <div className="p-4">
              <h3 className="font-[Poppins] font-medium text-[12px] sm:text-[13px] md:text-[14.37px] leading-[150%] text-[#031722] mb-2">
                {property.type}
              </h3>
              <p className="font-[Poppins] font-normal text-[10px] sm:text-[10.5px] md:text-[11.17px] text-[#6A6A6A] mb-4">
                {property.location}
              </p>
              <p className="font-[Poppins] font-normal text-[8.5px] sm:text-[9px] md:text-[9.58px] text-[#797979] mb-4">
                {property.postedTime}
              </p>

              {/* Contact Button */}
              <button className="w-full bg-red-500 hover:bg-red-600 text-white font-semibold py-2 rounded-2xl transition-colors">
                Contact Agent
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PopularProperties;
